export default __webpack_public_path__ + "c4618ceb3114df09dbbc170a1a68a276.png";